import React from "react";
import { Link } from "react-router-dom";
import { Mail, MapPin, Phone } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-border bg-muted/30 mt-24" data-testid="footer">
      <div className="container-x py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-2 mb-4">
            <img
              src="https://customer-assets-gfyr7b9c.emergentagent.net/job_horizon-book-1/artifacts/ws7lgoor_SYNWOR.webp"
              alt="Synergie Workspace"
              className="h-10 w-auto mix-blend-multiply dark:mix-blend-screen dark:invert"
            />
            <span className="font-heading font-semibold text-lg">Synergie Workspace</span>
          </div>
          <p className="text-sm text-muted-foreground leading-relaxed max-w-xs">
            Un espace de travail chaleureux, lumineux et inspirant — pensé pour les indépendants et les équipes.
          </p>
        </div>
        <div>
          <p className="overline mb-3">Navigation</p>
          <ul className="space-y-2 text-sm">
            <li><Link to="/reserver" className="hover:text-[#2B8B8E]">Réserver</Link></li>
            <li><Link to="/tarifs" className="hover:text-[#2B8B8E]">Tarifs</Link></li>
            <li><Link to="/a-propos" className="hover:text-[#2B8B8E]">À propos</Link></li>
            <li><Link to="/contact" className="hover:text-[#2B8B8E]">Contact</Link></li>
          </ul>
        </div>
        <div>
          <p className="overline mb-3">Compte</p>
          <ul className="space-y-2 text-sm">
            <li><Link to="/connexion" className="hover:text-[#2B8B8E]">Connexion</Link></li>
            <li><Link to="/inscription" className="hover:text-[#2B8B8E]">Inscription</Link></li>
            <li><Link to="/mon-compte" className="hover:text-[#2B8B8E]">Mon compte</Link></li>
          </ul>
        </div>
        <div>
          <p className="overline mb-3">Contact</p>
          <ul className="space-y-3 text-sm text-muted-foreground">
            <li className="flex items-start gap-2"><MapPin size={14} className="mt-0.5" /> Vauvert, 30600, Gard</li>
            <li className="flex items-start gap-2"><Phone size={14} className="mt-0.5" /> 07 62 36 95 51</li>
            <li className="flex items-start gap-2"><Mail size={14} className="mt-0.5" /> synergieworkspace@gmail.com</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-border py-4 text-center text-xs text-muted-foreground">
        © {new Date().getFullYear()} Synergie Workspace Vauvert — Tous droits réservés · <Link to="/cgu" className="hover:text-[#2B8B8E]" data-testid="footer-cgu">CGU</Link> · <Link to="/rgpd" className="hover:text-[#2B8B8E]" data-testid="footer-rgpd">Confidentialité</Link>
      </div>
    </footer>
  );
}
